import { dynamicImport } from '@canvas/dynamic-import';
import { type ExternalMessageLoader, type SupportedLocale } from '@canvas/intl';

import { combineExternalMessages } from './utils';

export const emojiMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/de'))],
  'en-GB': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en_GB'))],
  'en-US': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en'))],
  cs: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/cs'))],
  ko: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/ko'))],
  'pt-BR': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/pt_BR'))],
  fr: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/fr'))],
  es: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/es'))],
  it: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/it'))],
  ja: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/ja'))],
  nl: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/nl'))],
  nb: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/nb'))],
  da: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/da'))],
  sv: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/sv'))],
  fi: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/fi'))],
  ru: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/ru'))],
  pl: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/pl'))],
  tr: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/tr'))],
  hu: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/hu'))],
  'zh-CN': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/zh'))],
  'zh-TW': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/zh_TW'))],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/de'))],
  xx: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/de'))],
  en: [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en'))],
  'en-ZZ': [() => dynamicImport(() => import('@atlaskit/emoji/dist/es2019/i18n/en_ZZ'))],
};

export const linkPickerMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/de'))],
  'en-GB': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/en_GB')),
  ],
  'en-US': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/en')),
  ],
  cs: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/cs'))],
  ko: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/ko'))],
  'pt-BR': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/pt_BR')),
  ],
  fr: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/fr'))],
  es: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/es'))],
  it: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/it'))],
  ja: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/ja'))],
  nl: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/nl'))],
  nb: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/nb'))],
  da: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/da'))],
  sv: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/sv'))],
  fi: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/fi'))],
  ru: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/ru'))],
  pl: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/pl'))],
  tr: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/tr'))],
  hu: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/hu'))],
  'zh-CN': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/zh')),
  ],
  'zh-TW': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/zh_TW')),
  ],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/de')),
  ],
  xx: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/de'))],
  en: [() => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/en'))],
  'en-ZZ': [
    () => dynamicImport(() => import('@atlaskit/link-picker/dist/es2019/i18n/en_ZZ')),
  ],
};

export const editorMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> =
  // We need to include messages from packages that the editor depends on
  combineExternalMessages(emojiMessagesMap, linkPickerMessagesMap, {
    de: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/de')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/de')),
    ],
    'en-GB': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/en_GB')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/en_GB')),
    ],
    'en-US': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/en')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/en')),
    ],
    cs: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/cs')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/cs')),
    ],
    ko: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/ko')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/ko')),
    ],
    'pt-BR': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/pt_BR')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/pt_BR')),
    ],
    fr: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/fr')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/fr')),
    ],
    es: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/es')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/es')),
    ],
    it: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/it')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/it')),
    ],
    ja: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/ja')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/ja')),
    ],
    nl: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/nl')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/nl')),
    ],
    nb: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/nb')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/nb')),
    ],
    da: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/da')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/da')),
    ],
    sv: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/sv')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/sv')),
    ],
    fi: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/fi')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/fi')),
    ],
    ru: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/ru')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/ru')),
    ],
    pl: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/pl')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/pl')),
    ],
    tr: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/tr')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/tr')),
    ],
    hu: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/hu')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/hu')),
    ],
    'zh-CN': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/zh')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/zh')),
    ],
    'zh-TW': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/zh_TW')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/zh_TW')),
    ],
    // We prefer German translations for pseudo-locale as it is quite long and helps manually test
    'en-pseudo': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/de')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/de')),
    ],
    xx: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/de')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/de')),
    ],
    en: [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/en')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/en')),
    ],
    'en-ZZ': [
      () => dynamicImport(() => import('@atlaskit/editor-core/dist/es2019/i18n/en_ZZ')),
      () => dynamicImport(() => import('@atlaskit/editor-common/dist/es2019/i18n/en_ZZ')),
    ],
  });

export const smartCardMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/de'))],
  'en-GB': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en_GB')),
  ],
  'en-US': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en')),
  ],
  cs: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/cs'))],
  ko: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/ko'))],
  'pt-BR': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/pt_BR')),
  ],
  fr: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/fr'))],
  es: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/es'))],
  it: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/it'))],
  ja: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/ja'))],
  nl: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/nl'))],
  nb: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/nb'))],
  da: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/da'))],
  sv: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/sv'))],
  fi: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/fi'))],
  ru: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/ru'))],
  pl: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/pl'))],
  tr: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/tr'))],
  hu: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/hu'))],
  'zh-CN': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/zh')),
  ],
  'zh-TW': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/zh_TW')),
  ],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/de')),
  ],
  xx: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/de'))],
  en: [() => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en'))],
  'en-ZZ': [
    () => dynamicImport(() => import('@atlaskit/smart-card/dist/es2019/i18n/en_ZZ')),
  ],
};

export const DatasourceMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> = {
  de: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/de')),
  ],
  'en-GB': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en_GB')),
  ],
  'en-US': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en')),
  ],
  cs: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/cs')),
  ],
  ko: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/ko')),
  ],
  'pt-BR': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/pt_BR')),
  ],
  fr: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/fr')),
  ],
  es: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/es')),
  ],
  it: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/it')),
  ],
  ja: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/ja')),
  ],
  nl: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/nl')),
  ],
  nb: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/nb')),
  ],
  da: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/da')),
  ],
  sv: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/sv')),
  ],
  fi: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/fi')),
  ],
  ru: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/ru')),
  ],
  pl: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/pl')),
  ],
  tr: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/tr')),
  ],
  hu: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/hu')),
  ],
  'zh-CN': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/zh')),
  ],
  'zh-TW': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/zh_TW')),
  ],
  // We prefer German translations for pseudo-locale as it is quite long and helps manually test
  'en-pseudo': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/de')),
  ],
  xx: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/de')),
  ],
  en: [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en')),
  ],
  'en-ZZ': [
    () => dynamicImport(() => import('@atlaskit/link-datasource/dist/es2019/i18n/en_ZZ')),
  ],
};

export const reactionsMessagesMap: Record<SupportedLocale, ExternalMessageLoader[]> =
  // We need to include messages from packages that reactions depends on
  combineExternalMessages(emojiMessagesMap, {
    de: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/de'))],
    'en-GB': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en_GB')),
    ],
    'en-US': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en')),
    ],
    cs: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/cs'))],
    ko: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/ko'))],
    'pt-BR': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/pt_BR')),
    ],
    fr: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/fr'))],
    es: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/es'))],
    it: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/it'))],
    ja: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/ja'))],
    nl: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/nl'))],
    nb: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/nb'))],
    da: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/da'))],
    sv: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/sv'))],
    fi: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/fi'))],
    ru: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/ru'))],
    pl: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/pl'))],
    tr: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/tr'))],
    hu: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/hu'))],
    'zh-CN': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/zh')),
    ],
    'zh-TW': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/zh_TW')),
    ],
    // We prefer German translations for pseudo-locale as it is quite long and helps manually test
    'en-pseudo': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/de')),
    ],
    xx: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/de'))],
    en: [() => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en'))],
    'en-ZZ': [
      () => dynamicImport(() => import('@atlaskit/reactions/dist/es2019/i18n/en_ZZ')),
    ],
  });
